<template>
  <a-form
    class="login-form"
    status-icon
    ref="formLogin"
    :form="form"
    @submit="handleSubmit"
    label-width="0">
    <a-form-item>
      <a-input
        size="large"
        v-decorator="[
          'username',
          {rules: [{ required: true, message: '请输入帐户名' }], validateTrigger: 'change'}
        ]"
        placeholder="请输入用户名">
        <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }"/>
      </a-input>
    </a-form-item>
    <a-form-item>
      <a-input
        size="large"
        type="password"
        v-decorator="[
          'password',
          {rules: [{ required: true, message: '请输入密码' }], validateTrigger: 'blur'}
        ]"
        placeholder="请输入密码">
        <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }"/>
      </a-input>
    </a-form-item>
    <a-form-item>
      <a-row :span="24">
        <a-col :span="16">
          <a-input
            size="large"
            auto-complete="off"
            v-decorator="[
              'code',
              {rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'blur'}
            ]"
            placeholder="请输入验证码">
            <a-icon slot="prefix" type="insurance" :style="{ color: 'rgba(0,0,0,.25)' }"/>
          </a-input>
        </a-col>
        <a-col :span="8">
          <div class="login-code">
            <span
              class="login-code-img"
              @click="refreshCode"
              v-if="code.type == 'text'">{{ code.value }}</span>
            <img
              :src="code.src"
              class="login-code-img"
              @click="refreshCode"
              v-else/>
          </div>
        </a-col>
      </a-row>

    </a-form-item>
    <a-form-item>
      <a-button
        size="large"
        type="primary"
        :loading="loginBtn"
        :disabled="loginBtn"
        htmlType="submit"
        class="login-submit">登录</a-button>
    </a-form-item>
  </a-form>
</template>

<script>
import { mapActions } from 'vuex'
import { timeFix, randomLenNum } from '@/utils/util'
export default {
  data () {
    return {
      loginBtn: false,
      form: this.$form.createForm(this),
      code: {
        src: '/code',
        value: '',
        len: 4,
        type: 'image'
      },
      randomStr: ''
    }
  },
  created () {
    this.refreshCode()
  },
  methods: {
    ...mapActions(['Login', 'Logout']),
    refreshCode () {
      this.randomStr = randomLenNum(this.code.len, true)
      this.code.type === 'text' ? (this.code.value = randomLenNum(this.code.len)) : (this.code.src = `/api/code/${this.randomStr}`)
    },
    handleSubmit (e) {
      e.preventDefault()
      this.loginBtn = true
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          const loginParams = { ...values }
          loginParams.randomStr = this.randomStr
          this.Login(loginParams)
            .then((res) => this.loginSuccess(res))
            .catch(err => this.requestFailed(err))
            .finally(() => {
              this.loginBtn = false
            })
        } else {
          setTimeout(() => {
            this.loginBtn = false
          }, 600)
        }
      })
    },
    loginSuccess (res) {
      // 延迟 1 秒显示欢迎信息
      this.$router.push({ name: 'card' })
      setTimeout(() => {
        this.$notification.success({
          message: '欢迎',
          description: `${timeFix()}，欢迎回来`
        })
      }, 1000)
    },
    requestFailed (err) {
      this.refreshCode()
      this.$notification['error']({
        message: '错误',
        description: ((err.response || {}).data || {}).message || '账号或密码错误,请重新输入',
        duration: 4
      })
    }
  }
}
</script>

<style>
</style>
